let accordions = {
    init : function() {
        let accordionContainers = document.getElementsByClassName('read-more-accordion');
        if (accordionContainers.length > 0) {
            for (let i = 0; i < accordionContainers.length; i++) {
                accordionContainers[i]
                    .querySelector('.read-more-accordion-button')
                    .addEventListener('click', (event) => {
                        event.stopPropagation();
                        event.target
                           .parentElement
                           .querySelector('.read-more-accordion-content')
                           .classList.toggle('show');
                    });
            }
            return true;
        } else return false;
    }
};

module.exports = accordions;